import { render, staticRenderFns } from "./Youngs.vue?vue&type=template&id=f084ea34&"
import script from "./Youngs.vue?vue&type=script&lang=js&"
export * from "./Youngs.vue?vue&type=script&lang=js&"
import style0 from "./Youngs.vue?vue&type=style&index=0&id=f084ea34&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports